<script setup lang="ts">
import { computed } from "vue";

import { cardKey } from "@/components/StickyNote/injectKeys";
import { boardKey } from "@/components/board/injectKeys";
import MirrorStickyChip from "@/components/chip/MirrorStickyChip.vue";
import ROAMChip from "@/components/chip/ROAMChip/ROAMChip.vue";
import StickyLinksChip from "@/components/chip/StickyLinksChip.vue";
import UserChip from "@/components/chip/UserChip/UserChip.vue";
import { isRiskBoard as isRiskBoardType } from "@/model/board";
import { useBoardStore } from "@/store/board";
import { useTeamStore } from "@/store/team";
import { injectStrict } from "@/utils/vue";

import StickyNoteRow from "../../../StickyNoteRow/StickyNoteRow.vue";

const board = injectStrict(boardKey);
const card = injectStrict(cardKey);

const isActive = computed(() => useBoardStore().activeCardId === card.id);
const isRiskBoard = computed(() => isRiskBoardType(board.value.type));

const teamName = computed(() => {
  const teams = useTeamStore().teamsInCurrentArt;
  return teams.find((team) => team.id === card.teamId)?.name;
});
</script>

<template>
  <StickyNoteRow class="risk-footer">
    <UserChip />
    <span v-if="isRiskBoard && teamName" class="team-name">{{ teamName }}</span>
    <StickyLinksChip :linking-card="{ type: 'sticky', id: card.id }" show-upper-level-links />
    <MirrorStickyChip v-if="isActive" />
    <div v-if="!isRiskBoard" class="roam">
      <ROAMChip />
    </div>
  </StickyNoteRow>
</template>

<style lang="scss" scoped>
@use "@/styles/mixins/utils";

.risk-footer {
  .team-name {
    @include utils.ellipsis;
  }

  .roam {
    margin-left: auto;
  }
}
</style>
